import { IonItem, IonText } from '@ionic/react';
import { SimpleProduct } from '../../types/product.type';
import './ProductListItem.scss'
import { useRef } from 'react';
import { getPriceFactor, getProductImageUrl } from '../../functions/product.functions';
import { useAppContext } from '../../services/app-context.service';
import ProgressiveImg from '../ProgressiveImg';
type Props = {
    product: SimpleProduct
}
const ProductListItem: React.FC<Props> = ({ product }) => {
    const modal = useRef<HTMLIonModalElement>(null)
    const data = useAppContext()
    const priceFactor = getPriceFactor(data.settings)
    return <IonItem className='product' onClick={() => modal.current?.present()}>
        <ProgressiveImg
            src={getProductImageUrl(product.img, 100)}
            slot='start' />
        <div className='name'>
            <IonText>{product.title}</IonText>
        </div>
        <div className='pricing'>
            {/* <IonText className='regular'>{product.price} </IonText> */}
            <IonText className='sale' color='primary'>{Math.ceil(parseFloat(product.price) * priceFactor)}/=</IonText>
        </div>
    </IonItem>
};

export default ProductListItem;
